import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Footer from './Footer'
import Navbar from "./Navbar";

const PrivacyPolicy = () => {
  return (
    <div>
      <section>
        <Navbar />
      </section>


      <section className="top-section">
        <Box
          sx={{
            background: '#8a88bc',
            color: "white",
            textAlign: "center",
            py: { xs: 6, md: 10 },
          }}
        >

          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Privacy Policy
          </Typography>

          <Typography variant="h6" maxWidth="700px" mx="auto">
            Empowering students with skills and knowledge for a brighter future.
          </Typography>
        </Box>
      </section>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          {/* Heading */}
          <Typography variant="h4" gutterBottom fontWeight="bold" color="primary">
            Privacy Policy
          </Typography>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Last Updated: September 26, 2025
          </Typography>

          {/* Intro */}
          <Typography paragraph>
            At <strong>Medby Academy</strong> ("we," "us," or "our"), we are
            committed to protecting your privacy and ensuring the security of your
            personal information. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your information when you visit our
            website <strong>www.medbyacademy.com</strong> (the "Website"), enroll
            in our courses, or otherwise interact with our services
            (collectively, the "Services").
          </Typography>
          <Typography paragraph>
            By using the Website or Services, you consent to the practices
            described in this Privacy Policy. If you do not agree with this
            Privacy Policy, please do not access or use our Services.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* Sections */}
          <Box>
            <Typography variant="h6" gutterBottom>
              1. Information We Collect
            </Typography>
            <Typography paragraph>
              We collect information that you provide directly to us, as well as
              information collected automatically when you use our Services.
            </Typography>

            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              1.1 Personal Information
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="Contact Information" secondary="Name, email address, phone number, mailing address." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Account Information" secondary="Username, password, and other registration details." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Payment Information" secondary="Credit/debit card details, billing address, processed securely via third-party gateways (we do not store full details)." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Professional Information" secondary="Qualifications, medical specialty, licensing details, or educational background." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Other Information" secondary="Any additional data you provide, such as feedback, survey responses, or support communications." />
              </ListItem>
            </List>

            <Typography variant="subtitle1" gutterBottom fontWeight="bold" sx={{ mt: 2 }}>
              1.2 Automatically Collected Information
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="Usage Data" secondary="Pages visited, time spent, browser type, operating system, IP address, device identifiers, referral sources." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Cookies & Tracking" secondary="We use cookies, web beacons, and similar technologies to track activity, remember preferences, and improve Services." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Log Data" secondary="Server logs record access times, errors, and technical details." />
              </ListItem>
            </List>

            <Divider sx={{ my: 3 }} />

            {/* Example of next sections */}
            <Typography variant="h6" gutterBottom>
              2. How We Use Your Information
            </Typography>
            <List dense>
              <ListItem><ListItemText primary="Provide Services" secondary="Process enrollments, deliver content, issue certificates." /></ListItem>
              <ListItem><ListItemText primary="Communications" secondary="Send updates, offers, newsletters, and respond to inquiries." /></ListItem>
              <ListItem><ListItemText primary="Payments & Fraud Prevention" /></ListItem>
              <ListItem><ListItemText primary="Service Improvements" secondary="Analyze usage trends and personalize your experience." /></ListItem>
              <ListItem><ListItemText primary="Legal Compliance" secondary="Enforce Terms & Conditions and protect our rights." /></ListItem>
            </List>

            {/* Continue in the same style for: Sharing Your Info, Data Security, Cookies, Rights, Children’s Privacy, etc. */}

            <Divider sx={{ my: 3 }} />

            {/* Contact */}
            <Typography variant="h6" gutterBottom>
              11. Contact Us
            </Typography>
            <Typography paragraph>
              If you have questions about this Privacy Policy, please contact us:
            </Typography>
            <Typography>Email: support@medbyacademy.com</Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
              Thank you for trusting Medby Academy with your information. We are
              dedicated to maintaining your privacy while supporting your medical
              education.
            </Typography>
          </Box>
        </Paper>
      </Container>
      <section>
        <Footer />
      </section>
    </div>


  );
};

export default PrivacyPolicy;
